
import { Component } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import PageRequest from '@/store/entities/page-request';
import EditOrder from './editOrder.vue';
import TenantSelectionList from '@/components/tenant-selection-list.vue';
import Membership from '@/store/entities/auth/Membership';
import AppConsts from '@/lib/appConst';

class PageOrderRequest extends PageRequest {
    keyword: string;
    tenantId: number;
    from: Date;
    to: Date;
    userNo: string;
    status: number;
}

@Component({
    components: {
        EditOrder,
        TenantSelectionList,
    }
})
export default class Orders extends AbpBase {
    pagerequest: PageOrderRequest = new PageOrderRequest();
    creationTime: Date[] = []; //[new Date(), new Date()];
    currentTab: string = "0";
    editMode: string = null;
    createModalShow: boolean = false;
    editModalShow: boolean = false;
    canEdit: boolean = true; // abp.auth.isGranted("Pages.Order.Edit");
    canDelete: boolean = true; // abp.auth.isGranted("Pages.Order.Delete");
    canTenant: boolean = abp.auth.isGranted('Pages.Tenants');
    columns = [
        {
            title: this.L('ProductImageUrl'),
            width: 110,
            render: (h: any, params: any) => {
                return h('img', {
                    attrs: {
                        src: params.row.productImageUrl,
                    },
                    style: {
                        width: '60px',
                        paddingTop: '10px',
                        paddingBottom: '5px',
                        cursor: 'pointer'
                    },
                    on: {
                        click: () => {
                            if (!params.row.productNo) { return; }
                            window.open('/product?id=' + params.row.productNo, '_blank');
                        }
                    }
                })
            }
        },
        {
            title: this.L('OrderNo'),
            key: 'orderNo'
        },
        {
            title: this.L('PayableAmount'),
            key: 'payableAmount'
        },
        {
            title: this.L('PaidAmount'),
            key: 'paidAmount'
        },
        {
            title: this.L('AuthMode'),
            key: 'authMode',
            width: 90,
        },
        {
            title: this.L('Order') + this.L('CreationTime'),
            key: 'creationTime'
        },
        {
            title: ' ',
            key: 'Actions',
            width: 100,
            style: {
                display: 'none'
            },
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px',
                            display: (this.getStatus() == 0 ? '' : 'none')
                        },
                        on: {
                            click: () => {
                                this.$store.state.order.loading = true;
                                this.$store.dispatch({
                                    type: 'order/getByNo',
                                    data: params.row
                                }).then((data) => {
                                    this.handlePay(data);
                                    this.$store.state.order.loading = false;
                                });
                            }
                        }
                    }, this.L('PayImmediately')),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px',
                            display: (this.getStatus() == 1 ? '' : 'none')
                        },
                        on: {
                            click: () => {
                                this.$store.state.order.loading = true;
                                this.$store.dispatch({
                                    type: 'order/getByNo',
                                    data: params.row
                                }).then((data) => {
                                    this.handleTakeDelivery(params.row);
                                    this.$store.state.order.loading = false;
                                });
                            }
                        }
                    }, this.L('TakeDelivery')),
                    // h('Button', {
                    //     props: {
                    //         type: 'primary',
                    //         size: 'small',
                    //         disabled: !params.row.canRefund
                    //     },
                    //     style: {
                    //         marginRight: '5px',
                    //         display: ((this.getStatus() == 1 || this.getStatus() == 3) ? '' : 'none')
                    //     },
                    //     on: {
                    //         click: () => {
                    //             this.$store.state.order.loading = true;
                    //             this.$store.dispatch({
                    //                 type: 'order/getByNo',
                    //                 data: params.row
                    //             }).then((data) => {
                    //                 this.handleApplyRefund(data);
                    //                 this.$store.state.order.loading = false;
                    //             });
                    //         }
                    //     }
                    // }, this.L('ApplyRefund')),
                    h('span', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px',
                            display: (params.row.status == 2 ? '' : 'none')
                        }
                    }, this.L('AwaitRefund')),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px',
                            display: ((params.row.status == 3 || params.row.status == 5) ? '' : 'none')
                        },
                        on: {
                            click: () => {
                                if (!params.row.linkUrl) { return; }
                                this.$Modal.info({
                                    title: this.L('Download'),
                                    content: '<div>' + this.L('LinkUrl') + '：<a href="' + params.row.linkUrl + '" target="_blank" style="color:#ad0804">' + this.L('DownloadImmediately') + '</a></div><div>' + this.L('LinkUrlKey') + '：' + params.row.linkUrlKey + '</div>'
                                });
                                window.open(params.row.linkUrl, '_blank');
                            }
                        }
                    }, this.L('DownloadImmediately')),
                    h('span', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px',
                            display: (params.row.status == 4 ? '' : 'none')
                        }
                    }, this.L('Refunded')),
                ])
            }
        }];

    get tenant() {
        return Util.abp.multiTenancy.getTenantCookie();
    }

    get isStandardEdition() {
        return Util.isStandardEdition();
    }

    get transactionType() {
        return this.tenant.transactionType;
    }

    get wallet() {
        return this.$store.state.wallet.editWallet;
    }

    get list() {
        return this.$store.state.order.list;
    }

    get loading() {
        return this.$store.state.order.loading;
    }

    get membership() {
        if (this.$store.state.session.membership) {
            return this.$store.state.session.membership;
        } else {
            return new Membership();
        }
    }

    mounted() {
        this.setColumns();
    }

    /**
     * 设置列
    */
    setColumns() {
        // 虚拟商品才需要授权模式
        if (this.transactionType !== 0) {
            const authModeColumn = this.columns.find(x => x.key === 'authMode');
            const indexOfAuthModeColumn = this.columns.indexOf(authModeColumn);
            this.columns.splice(indexOfAuthModeColumn, 1);
        }
    }

    handleTabChanged(e) {
        this.currentTab = e;
        this.changePage(1);
    }

    getStatus() {
        return parseInt(this.currentTab);
    }

    edit() {
        this.editMode = "Update";
        this.editModalShow = true;
    }

    changePage(page: number) {
        this.$store.commit('order/setCurrentPage', page);
        this.getData();
    }

    pagesizeChange(pagesize: number) {
        this.$store.commit('order/setPageSize', pagesize);
        this.getData();
    }

    getWallet() {
        this.$store.dispatch({
            type: 'wallet/getByUser',
            data: {
                userNo: Util.abp.session.getUserNoCookie()
            },
        });
    }

    getData() {
        this.getWallet();
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        this.pagerequest.userNo = Util.abp.session.getUserNoCookie();
        this.pagerequest.status = parseInt(this.currentTab);

        //filters
        if (this.creationTime.length > 0) {
            this.pagerequest.from = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.to = this.creationTime[1];
        }

        this.$store.dispatch({
            type: 'order/getAllByUser',
            data: this.pagerequest
        })
    }

    get pageSize() {
        return this.$store.state.order.pageSize;
    }

    get totalCount() {
        return this.$store.state.order.totalCount;
    }

    get currentPage() {
        return this.$store.state.order.currentPage;
    }


    async created() {
        // hide operation column
        if (!this.canEdit && !this.canDelete) {
            this.columns.splice(this.columns.length - 1, 1);
        }

        if (this.$route.query.tab) {
            this.currentTab = this.$route.query.tab.toString();
            this.changePage(1);
        } else {
            this.getData();
        }
    }

    handlePay(order) {
        order.orderId = order.id;
        this.getWallet();
        let that = this;
        let paidAmount = order.payableAmount;

        // 在提交订单时已经计算了折扣，这里无需再计算一次折扣
        // if (this.membership.discount && !this.membership.isExpired) {
        //     paidAmount *= this.membership.discount;
        // }

        if (this.wallet.balance < paidAmount) {
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: this.L('BalanceNotEnough'),
                onOk: () => {
                    window.open('/pc/coin-charging', '_blank');
                },
            });
            return;
        }

        this.$Modal.confirm({
            title: this.L('Tips'),
            content: this.L('PaymentTips' + this.transactionType, undefined, (paidAmount * 1).toString()),
            onOk: () => {
                this.$store.state.order.loading = true;
                this.$store.dispatch({
                    type: 'wallet/pay',
                    data: order
                }).then((data) => {
                    that.$Message.success({ content: this.L('PaidSuccessful'), duration: 3 });
                    setTimeout(() => {
                        that.getData();
                    }, 3000);
                }).catch(err => {
                    this.$Message.error(this.L('PaymentFailed'));
                    this.$store.state.order.loading = false;
                });
            }
        });
    }

    handleTakeDelivery(order) {
        let that = this;
        window.open(order.linkUrl, '_blank');
        this.$Modal.info({
            title: this.L('Tips'),
            content: this.L('TakeDeliveryConfirm', undefined, order.orderNo) + '<br><br>' + this.L('TakeCareOfBelowInfo') + '：<br><div style="word-wrap:break-word">' + this.L('LinkUrl') + '：' + order.linkUrl + '</div>' + this.L('LinkUrlKey') + '：' + order.linkUrlKey,
            onOk: () => {
                this.$store.state.order.loading = true;
                this.$store.dispatch({
                    type: 'order/takeDelivery',
                    data: order.orderNo
                }).then((data) => {
                    that.$Message.success({ content: this.L('OperationSuccessful'), duration: 3 });
                    setTimeout(() => {
                        that.getData();
                    }, 3000);
                }).catch(err => {
                    this.$Message.error(this.L('OperationFailed'));
                    this.$store.state.order.loading = false;
                });
            }
        });
    }

    handleApplyRefund(order) {
        let that = this;

        this.$Modal.confirm({
            title: this.L('Tips'),
            content: this.L('ApplyRefundConfirm', undefined, order.orderNo),
            onOk: () => {
                this.$store.state.order.loading = true;
                this.$store.dispatch({
                    type: 'order/applyRefund',
                    data: order.orderNo
                }).then((data) => {
                    that.$Message.success({ content: this.L('OperationSuccessful'), duration: 3 });
                    setTimeout(() => {
                        that.getData();
                    }, 3000);
                }).catch(err => {
                    this.$Message.error(this.L('OperationFailed'));
                    this.$store.state.order.loading = false;
                });
            }
        });
    }
}
